/*
 * Web Framework Sticky Nav
 * Add the class .wf-sticky-nav to any element and it will "stick" to the top as you scroll down
 * MIT License
 * Originally from https://bootstrap-menu.com/detail-fixed-onscroll.html
 */
(function(document, $) {
  $( window ).on('scroll', function() {

    let wfSticky = $('.wf-sticky-nav');
    let docBody = document.body;
    let navbar_height = $('.wf-sticky-nav').offsetHeight;

    if (window.scrollY > 0) {
      $(wfSticky).addClass('fixed-top');
      $('html').addClass('sticky-body');
      // add padding top to show content behind navbar
      $(docBody).css('padding-top', navbar_height + 'px');
    } else {
      $(wfSticky).removeClass('fixed-top');
      $('html').removeClass('sticky-body');
      // remove padding top from body
      $(docBody).css('padding-top', '0');
    } 

  });
})(document, jQuery);